import { MarcacaoConsultaPK } from "../marcacao/marcacao-consulta/pks/marcacao-consulta-pk";
import { InformacaoFechamentoMarcacaoDTO } from "./informacao-fechamento-marcacao-dto";

export class InformacaoFechamentoMarcacaoConsultaDTO extends InformacaoFechamentoMarcacaoDTO {

    pkMarcacao: MarcacaoConsultaPK | undefined;

}
